module.exports = __webpack_public_path__ + "img/chooseicon.2b6b5681.svg";